import { useChatStatus, useMessageIds } from '@mui/x-chat/headless';
import type { ChatMessage } from '@mui/x-chat/types';

import { isDefined } from 'common';

import { AgenticChatQuestionCard } from './Card';
import { parseAgenticChatQuestion } from './utils';

interface AgenticChatQuestionPartProps {
  data: unknown;
  message: ChatMessage;
}

/** Renders an ask-user part as the question card, open only while it is the last word. */
export function AgenticChatQuestionPart(props: AgenticChatQuestionPartProps) {
  const { data, message } = props;
  const messageIds = useMessageIds();
  const { isStreaming } = useChatStatus();
  const question = parseAgenticChatQuestion(data);

  if (!isDefined(question)) {
    return null;
  }

  return (
    <AgenticChatQuestionCard
      question={question}
      isOpen={!isStreaming && messageIds.at(-1) === message.id}
    />
  );
}
